export type CookiePreferences = {
  essential: true;
  preferences: boolean;
  analytics: boolean;
  marketing: boolean;
  updatedAt: string;
};

export const COOKIE_PREFERENCES_KEY = 'lovibook-cookie-preferences';

type CookiePreferencesListener = (preferences: CookiePreferences) => void;

const listeners = new Set<CookiePreferencesListener>();

export const defaultCookiePreferences = (): CookiePreferences => ({
  essential: true,
  preferences: false,
  analytics: false,
  marketing: false,
  updatedAt: '',
});

export function readCookiePreferences(): CookiePreferences {
  if (typeof window === 'undefined') {
    return defaultCookiePreferences();
  }

  const storedValue = window.localStorage.getItem(COOKIE_PREFERENCES_KEY);
  if (!storedValue) {
    return defaultCookiePreferences();
  }

  try {
    const parsed = JSON.parse(storedValue) as Partial<CookiePreferences>;
    return {
      essential: true,
      preferences: Boolean(parsed.preferences),
      analytics: Boolean(parsed.analytics),
      marketing: Boolean(parsed.marketing),
      updatedAt: typeof parsed.updatedAt === 'string' ? parsed.updatedAt : '',
    };
  } catch (error) {
    void error;
    return defaultCookiePreferences();
  }
}

export function hasSavedCookiePreferences() {
  return typeof window !== 'undefined' && Boolean(window.localStorage.getItem(COOKIE_PREFERENCES_KEY));
}

export function saveCookiePreferences(preferences: CookiePreferences) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(preferences));
  }
  listeners.forEach((listener) => listener(preferences));
}

export function subscribeToCookiePreferences(listener: CookiePreferencesListener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
